import React from 'react';
import { useEffect,useState,useContext} from 'react';
import PopModal from '../../Constant/Custom/Models/PopModal';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Auth/AuthContext';

 const Duplicate = ({CorrectApplicationNumber}) => {
     const { auth, logoutUser } = useContext(AuthContext);
    const navigate =useNavigate();
   const openModal = () => setIsModalOpen(true);
   const closeModal = () => setIsModalOpen(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const [onConfirm, setOnConfirm] = useState(() => () => {});

    useEffect(()=>{
        // console.log(CorrectApplicationNumber);
        setModalType({
        icon: "info",
        title: "Duplicate Application",
        text: `<b>Since you have registered multiple applications</b><br/><br/> Login with your verified application number - ${CorrectApplicationNumber}`,
      });
      setOnConfirm(() => logoutUser);
      openModal();

    },[])


  return (
    <div>
           <PopModal
        isOpen={isModalOpen}
        onConfirm={onConfirm}
        type={modalType}
      />
    </div>
  )
}
export default Duplicate;
